// import { MemberActionType } from '../../actions/member/memberTypes';
import { MenuVoActionType } from '@/reducers/V2/V2Actions/MenuVo/MenuVoTypes';

const initialState: any = {
  MenuVoList: [],
  MenuCategories: [],
  MenuWebItemVos: [],
  MenuAttributeMap: {},
};

const MenuVoReducer: (state: any, action: any) => any = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case MenuVoActionType.SET_MENU_VO_LIST:
      return {
        ...state,
        MenuVoList: payload,
      };
    case MenuVoActionType.SET_MENU_VO_CATEGORIES:
      return {
        ...state,
        MenuCategories: payload,
      };
    case MenuVoActionType.SET_MENU_VO_WEBITEMVOS:
      return {
        ...state,
        MenuWebItemVos: payload,
      };
    case MenuVoActionType.SET_MENU_VO_ATTRIBUTEMAP:
      return {
        ...state,
        MenuAttributeMap: payload,
      };
    default:
      return state;
  }
};

export default MenuVoReducer;
